(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[975],{

/***/ 666:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CountryLandingPage": function() { return /* binding */ CountryLandingPage; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5235);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var _tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(3621);
/* harmony import */ var pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4766);
/* harmony import */ var pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(pwa_mmt_ui_header_ssr_header_css__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(2099);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(2322);


function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0,_opt_jenkins_workspace_TripMoney_Node_16_CDN_Docker_Submit_GitHub_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty_js__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }






var __N_SSP = true;
function CountryLandingPage(props) {
  var _ref = props || {},
      data = _ref.data;

  (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function () {
    if (data !== null && data !== void 0 && data.countryCode) {
      var searchParams = new URLSearchParams(window.location.search);
      var currentCountryCode = searchParams.get("countries");

      if (!currentCountryCode) {
        (0,_tm_insurance_utils__WEBPACK_IMPORTED_MODULE_2__/* .replaceHistory */ .df)("countries", data.countryCode);
      }
    }
  }, [data]);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_5__.jsx)(___WEBPACK_IMPORTED_MODULE_4__["default"], _objectSpread(_objectSpread({}, props), {}, {
    "data-test-id": "LandingPage"
  }));
}
/* harmony default export */ __webpack_exports__["default"] = (CountryLandingPage);

/***/ }),

/***/ 495:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/travel-insurance/[country]",
      function () {
        return __webpack_require__(666);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [147,535,753,99,774,888,179], function() { return __webpack_exec__(495); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);